<template xmlns="http://www.w3.org/1999/html">
    <b-modal
        id="edit-lp-deadline-modal"
        v-model="modal"
        ref="edit-lp-deadline-modal"
        size="md"
        :title="$t('learning_path.edit_period')"
        modal-class="apprentice-default-modal edit-deadline"
        :ok-title="$t('common.edit')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @ok="onOk">
        <div class="deadline-date-edit">
            <div
                class="errors"
                v-if="errorsFound">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    show
                    variant="danger"
                    :key="`error-${index}`"
                    >{{ error.message }}
                </b-alert>
            </div>
            <b-form-group
                class="deadline-name"
                label-for="deadline-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span></template>
                <b-form-input
                    id="lp-deadline-name-input"
                    v-model="name"
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>

            <div class="Start">
                <div class="date">
                    <b-form-group
                        label="Datum"
                        label-for="deadline-datepicker-input">
                        <template v-slot:label>
                            {{ $t('learning_path.start_date') }} <span class="required">*</span>
                        </template>
                        <b-form-datepicker
                            class="apprentice-date-picker btn-date-group"
                            id="start-datepicker-input"
                            v-model.lazy="startDate"
                            :config="dateConfig"
                            start-weekday="1"
                            now-button
                            reset-button
                            right
                            today-variant="primary"
                            nav-button-variant="primary"
                            locale="nl"
                            :aria-controls="$t('learning_path.choose_date')"
                            label-reset-button="reset"
                            :label-no-date-selected="$t('learning_path.no_date_selected')"
                            menu-class="datedropdown"
                            :date-format-options="{
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                                weekday: 'short',
                            }">
                        </b-form-datepicker>
                    </b-form-group>
                </div>
                <div class="time">
                    <b-form-group
                        :label="$t('learning_path.time')"
                        label-for="deadline-timepicker-input">
                        <template v-slot:label>
                            {{ $t('learning_path.start_time') }} <span class="required">*</span>
                        </template>
                        <design-2021-apprentice-timepicker-component v-model.lazy="startTime">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>
            </div>
            <div class="deadline">
                <div class="date">
                    <b-form-group
                        label="Datum"
                        label-for="deadline-datepicker-input">
                        <template v-slot:label>
                            {{ $t('learning_path.registration_deadline') }} <span class="required">*</span>
                        </template>
                        <b-form-datepicker
                            class="apprentice-date-picker btn-date-group"
                            id="deadline-datepicker-input"
                            v-model.lazy="deadline"
                            :config="dateConfig"
                            start-weekday="1"
                            now-button
                            reset-button
                            right
                            today-variant="primary"
                            nav-button-variant="primary"
                            locale="nl"
                            :aria-controls="$t('learning_path.choose_date')"
                            label-reset-button="reset"
                            :label-no-date-selected="$t('learning_path.no_date_selected')"
                            menu-class="datedropdown"
                            :date-format-options="{
                                year: 'numeric',
                                month: 'short',
                                day: '2-digit',
                                weekday: 'short',
                            }">
                        </b-form-datepicker>
                    </b-form-group>
                </div>
                <div class="time">
                    <b-form-group
                        :label="$t('learning_path.time')"
                        label-for="deadline-timepicker-input">
                        <template v-slot:label>
                            {{ $t('learning_path.time') }} <span class="required">*</span>
                        </template>
                        <design-2021-apprentice-timepicker-component v-model.lazy="deadlineTime">
                        </design-2021-apprentice-timepicker-component>
                    </b-form-group>
                </div>
            </div>
            <b-form-group
                class="assignments"
                label-for="assignment-multiselect"
                :label="$t('learning_path.exercises')">
                <design-2021-apprentice-multiselect-component
                    v-model="assignments"
                    label="name"
                    :allow-empty="true"
                    :options="lpAssignmentsIn"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import moment from 'moment';

export default {
    name: 'design-2021-update-learning-path-deadline-modal',
    props: ['lpAssignmentsIn'],
    data() {
        return {
            lpDeadline: null,
            name: null,
            loading: false,
            startDate: null,
            startTime: null,
            deadline: null,
            deadlineTime: null,
            assignments: [],
            dateConfig: {
                format: 'DD-MM-YYYY',
                useCurrent: false,
            },
            timeConfig: {
                format: 'H:mm',
                useCurrent: false,
                labelCloseButton: this.$t('common.close'),
                noCloseButton: true,
                icons: {
                    close: 'fa fa-times-circle',
                },
            },
            modal: false,
            errorsFound: false,
            errors: {
                name: {
                    error: false,
                    message: this.$t('learning_path.name_cannot_be_empty'),
                },
                startDate: {
                    error: false,
                    message: this.$t('learning_path.start_date_cannot_be_empty'),
                },
                startTime: {
                    error: false,
                    message: this.$t('learning_path.start_time_cannot_be_empty'),
                },
                deadline: {
                    error: false,
                    message: this.$t('learning_path.deadline_date_cannot_be_empty'),
                },
                deadlineTime: {
                    error: false,
                    message: this.$t('learning_path.deadline_time_cannot_be_empty'),
                },
            },
        };
    },

    methods: {
        onOk(bvModalEvent) {
            if (this.hasErrors()) {
                bvModalEvent.preventDefault();
                return;
            }
            const unixTimeStamp = Date.parse(this.startDate + ' ' + this.startTime);
            const datetime = new Date(unixTimeStamp);
            const unixTimeStamp2 = Date.parse(this.deadline + ' ' + this.deadlineTime);
            const datetime2 = new Date(unixTimeStamp2);
            let data = {
                id: this.lpDeadline.id,
                name: this.name,
                assignments: this.assignments.map((assignment) => assignment.id),
                startTime: datetime,
                deadline: datetime2,
            };
            this.alert.saving();
            this.axios.post(this.routes.updateLpDeadline(), data).then(
                (response) => {
                    this.$emit('updateDeadline', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        show(deadline) {
            this.errorsFound = false;
            this.errors.name.error = false;
            this.errors.startDate.error = false;
            this.errors.startTime.error = false;
            this.errors.deadline.error = false;
            this.errors.deadlineTime.error = false;
            this.lpDeadline = deadline;
            this.name = deadline.name;
            const oldDate = moment(deadline.start);
            this.startDate = oldDate.format('YYYY-MM-DD');
            this.startTime = oldDate.format('H:mm');
            const oldDeadline = moment(deadline.deadline);
            this.deadline = oldDeadline.format('YYYY-MM-DD');
            this.deadlineTime = oldDeadline.format('H:mm');
            this.assignments = deadline.lp_assignments;
            this.modal = true;
        },

        hasErrors() {
            this.errorsFound = false;
            this.errors.name.error = false;
            this.errors.name.error = false;
            this.errors.startDate.error = false;
            this.errors.startTime.error = false;
            this.errors.deadline.error = false;
            this.errors.deadlineTime.error = false;
            let errors = false;

            if (this.name === null || this.name === '') {
                this.errorsFound = true;
                this.errors.name.error = true;
                errors = true;
            }

            if (this.startDate === null || this.startDate === '') {
                this.errorsFound = true;
                this.errors.startDate.error = true;
                errors = true;
            }
            if (this.deadline === null || this.deadline === '') {
                this.errorsFound = true;
                this.errors.deadline.error = true;
                errors = true;
            }

            if (this.startTime === null || this.startTime === '') {
                this.errorsFound = true;
                this.errors.startTime.error = true;
                errors = true;
            }
            if (this.deadlineTime === null || this.deadlineTime === '') {
                this.errorsFound = true;
                this.errors.deadlineTime.error = true;
                errors = true;
            }

            return errors;
        },
    },
};
</script>

<style scoped lang="scss">
.Start ::v-deep,
.deadline ::v-deep {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: $grid-gutter-width;

    input {
        margin-bottom: 0;
    }

    .date {
        width: calc(67% - 15px);
    }

    .time {
        width: calc(33% - 15px);
    }
}
</style>
